import {useState} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {isAxiosError} from "axios";

export function useDeleteContact(contactID: string, onSuccess: () => void) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const submit = async () => {
        setLoading(true);
        setError("");
        try {
            await platformAPI.delete(`api/contacts/${contactID}`);
            onSuccess();
        } catch (e) {
            setError(isAxiosError(e) ? (e.response?.data?.error ?? "Failed to delete contact") : "Failed to delete contact");
        } finally {
            setLoading(false);
        }
    };

    return {submit, loading, error};
}
